import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { newDocumentoSettingsSelector } from "features/Crear/redux/selectors/newDocumentoSettingsSelectors"
import {
  selectExtraColor,
  updateColor,
} from "features/Crear/redux/slices/newDocumentoSettingsSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { nanoid } from "nanoid"
import { Button } from "primereact/button"
import { OverlayPanel } from "primereact/overlaypanel"
import { useRef } from "react"
import { useTranslation } from "react-i18next"
// @ts-expect-error TS(7016): Could not find a declaration file for module 'reac...
import { ChromePicker } from "react-color"

const DocumentoSettingsColorPrincipal = () => {
  const { t } = useTranslation()
  const menuNewColor = useRef()
  const dispatch = useDispatch()

  const { colorSelected, userColors, extraColor } = useSelector(
    newDocumentoSettingsSelector
  )

  const isSelectedColor = (color: $TSMigrationFixMe) => {
    return colorSelected === color
  }

  return (
    <div className='p-0 mt-3 col'>
      <p className='text-left'>{t("crear.facturaRec.principalColorLabel")}</p>
      <div className='px-2 row justify-content-start align-items-center'>
        {userColors.map((color: $TSMigrationFixMe) => (
          <Button
            key={nanoid()}
            className='ml-2 border-0 p-button-rounded btn-pick-color'
            style={{
              backgroundColor: color,
              color: isSelectedColor(color) ? "white" : "transparent",
            }}
            onClick={() => dispatch(updateColor(color))}
          >
            <FontAwesomeIcon
              icon={["fal", "check"]}
              className='normal-check-icon'
            />
          </Button>
        ))}
        <Button
          className='ml-2 border-0 p-button-rounded btn-pick-color'
          style={{
            backgroundColor: extraColor,
            color: "white",
          }}
          // @ts-expect-error TS(2339): Property 'toggle' does not exist on type 'never'.
          onClick={(e) => menuNewColor.current?.toggle(e)}
        >
          <FontAwesomeIcon
            icon={["fal", "plus"]}
            className='normal-check-icon'
          />
        </Button>
        {/* @ts-expect-error TS(2769): No overload matches this call. */}
        <OverlayPanel ref={menuNewColor}>
          <ChromePicker
            color={extraColor}
            onChange={({ hex }: $TSMigrationFixMe) =>
              dispatch(selectExtraColor(hex))
            }
          />
        </OverlayPanel>
      </div>
    </div>
  )
}

export default DocumentoSettingsColorPrincipal
